import { Suspense } from 'react';
import { AppRoutes } from '@/app/routes';
import { AppToaster } from '@/components/app/AppToaster';
import { AuthProvider } from '@/lib/auth';
import { ThemeProvider } from '@/lib/theme';
import { ImpersonationBanner } from '@/features/impersonation/ImpersonationBanner';
import { OfflineBanner } from '@/features/offline/OfflineBanner';
import { LocationScopeProvider } from '@/features/location/LocationScope';
import { AskFleetwise } from '@/features/help/AskFleetwise';
import { LanguageProvider } from '@/lib/i18n/LanguageProvider';

export function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        {/* Inside AuthProvider — the language belongs to the signed-in person,
            not the device, so it can only resolve once we know who that is. */}
        <LanguageProvider>
          <OfflineBanner />
          <ImpersonationBanner />
          <LocationScopeProvider>
            <Suspense fallback={null}>
              <AppRoutes />
            </Suspense>
            {/*
            Mounted once, here, rather than per layout: there is no ManagerLayout
            or LeadershipLayout (19 manager pages hand-roll their own header), so
            a layout-level mount would leave most of the app without help. Inside
            the router so it can read the current path; inside AuthProvider so it
            knows the role; it renders nothing when nobody is signed in.
          */}
            <AskFleetwise />
          </LocationScopeProvider>
        </LanguageProvider>
        <AppToaster />
      </AuthProvider>
    </ThemeProvider>
  );
}
